import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Card, Form, Button, } from 'react-bootstrap';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {useLocalStorage} from 'react-use';
import useNotif from 'hooks/use-notify-hook';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import './Auditee.css';

export default function Auditee({auditeeTeams = [], disabled, onChange}) {

  const { scheduleId } = useParams();

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);


  const handleChangeMembers = async selected => {

    try {

      const removed = auditeeTeams.find(member => !selected.includes(member));
      const added = selected.find(item => !auditeeTeams.includes(item));

      if (added) {

        /** Prevent duplicate team members */
        if (auditeeTeams.find(member => member.employee.EMP_ID === added.EMP_ID)) {
          return dispatchNotif({
            place: `br`,
            message: `Auditee Team Member already set.`,
            type: `danger`,
          });
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST}auditee-teams`,
          {
            SCHEDULE_ID: scheduleId,
            EMP_ID: added.employee.EMP_ID
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params: {
              expand: 'employee.user',
            }
          }
        );

        dispatchNotif({
          place: `br`,
          message: `Update Success...`,
          type: `success`,
        });

        return onChange([...auditeeTeams, { ...response.data }]);
      }

      if (removed) {

        const response = await axios.delete(`${process.env.REACT_APP_API_HOST}auditee-teams/${removed.AUDITEE_TEAM_ID}`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });

        dispatchNotif({
          place: `br`,
          message: `Update Success...`,
          type: `success`,
        });

        return onChange(selected);

      }

    } catch (error) {

      alert(`error`);
      console.log(error);

    }
  }


  const handleSearch = async (query) => {

    try {

      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}users`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          USER_STATUS: 1,
          search: query,
          expand: 'employee',
        }
      });

      setOptions(response.data.items);
      setIsLoading(false);

    } catch (error) {

      console.log(error);
      alert('error');
    }
  }



  return (
    <Card>
      {notif}
      <Card.Header>
        <Card.Title>Auditee Member(s)</Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group>
          <Form.Label>Type Name/Email</Form.Label>
          <AsyncTypeahead
            disabled={disabled}
            multiple
            filterBy={() => true}
            id="async-example"
            // defaultSelected={auditeeTeams}
            isLoading={isLoading}
            labelKey={({ employee: { EMP_NAME }}) => EMP_NAME}
            minLength={1}
            onChange={handleChangeMembers}
            selected={auditeeTeams}
            onSearch={handleSearch}
            options={options}
            placeholder="Search for an employee..."
            renderMenuItemChildren={({ employee: { EMP_NAME, EMP_EMAIL }}) => (
              <div>
                {EMP_NAME}
                <div>
                  <small>{EMP_EMAIL}</small>
                </div>
              </div>
            )}
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
}